import { Subdimensiones } from "../../../../../interfaces/Evaluations";
import { allLawsByYear, allYears } from "../../../utils/evaluationHelpers";

interface ILawsHeaderRow {
    evaluation_subDimension: Subdimensiones[];
    period: string;
}



const LawsHeaderRow = ({ evaluation_subDimension, period }: ILawsHeaderRow) => {
    const years = allYears(evaluation_subDimension).sort(
        (a: string, b: string) => parseInt(b) - parseInt(a)
    );

    return (
        <div className="bg-primary-25 flex px-3 h-[52px] gap-4 items-center min-w-fit ">
            {years.map((year: string) => {
                const laws = allLawsByYear(evaluation_subDimension, year)

                return laws.map((law: any, lawIndex: number) => {
                    const isLongText = (law?.law || "").length > 16;
                    const displayText = isLongText ? `${law.law.substring(0, 16)}...` : law.law;

                    return (
                        <div
                            key={`${year}-${lawIndex}`}
                            className={`w-[120px] sm:w-[140px] justify-center flex flex-col items-center ${period === year ? "text-[#F5A361]" : "text-indicator-null"
                                }`}
                        >
                            {law?.url ? (
                                <a
                                    href={law.url}
                                    className="text-tsmall text-center w-[120px] sm:w-[140px] underline hover:brightness-110 transition-all duration-200"
                                    title={isLongText ? law.law : ""}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {displayText}
                                </a>
                            ) : (
                                <span
                                    className="text-tsmall text-center w-[120px] sm:w-[140px]"
                                    title={isLongText ? law.law : ""}
                                >
                                    {displayText}
                                </span>
                            )}
                            <p className="text-tsmall font-semibold text-center w-[120px] sm:w-[140px]">
                                {year}
                            </p>
                        </div>
                    );
                });
            })}
        </div>
    );
};

export default LawsHeaderRow;